const escapeCharactersList = [
	"[", "]", "{", "}", "(", ")", "\\", "^", "$", ".", "|", "?", "*", "+"
];

export const escapeCharacters = (str = '') => escapeCharactersList.reduce((acc, char) => {
	acc = acc.replaceAll(char, escape(char));
	return acc;
}, str);
